import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import AccountService from 'wanderu-service-account';
import { SnowplowService } from 'wanderu-service-analytics';

import { logInAction } from '../logIn';
import { actions } from './base';

const logger = Logger.getLogger('wanderu-ducks-account');

function reset() {
    return actions.reset();
}

function confirm(email, code, newPassword) {
    return async (dispatch) => {
        dispatch(actions.startWork());

        let meta;
        let error;
        try {
            await AccountService.forgotPasswordConfirmation(email, code, newPassword);
            await dispatch(logInAction.cognitoLogIn(email, newPassword));
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('confirmPassword', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };
        } finally {
            dispatch(actions.endWork(meta, error));
        }
    };
}

export {
    confirm,
    reset,
};
